import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home, CheckCircle2, Sparkles, Trophy, Star } from "lucide-react";
import { appUrls } from "../../utils/use-get-page-url";

const celebrationMessages = [
  { icon: Trophy, message: "Outstanding work!", emoji: "🏆" },
  { icon: Star, message: "You're on fire!", emoji: "⭐" },
  { icon: Sparkles, message: "Fantastic job!", emoji: "✨" },
  { icon: CheckCircle2, message: "Mission accomplished!", emoji: "🎯" },
];

export const DonePage: React.FC = () => {
  const navigate = useNavigate();

  // Pick a random celebration message on mount
  const celebration = useMemo(
    () => celebrationMessages[Math.floor(Math.random() * celebrationMessages.length)],
    []
  );

  const Icon = celebration.icon;

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6 bg-gradient-to-b from-background to-muted/20 dark:bg-background">
      <div className="text-center space-y-6 max-w-md">
        {/* Animated icon */}
        <div className="relative inline-block">
          <div className="absolute inset-0 animate-ping opacity-20">
            <Icon className="h-32 w-32 text-primary" />
          </div>
          <Icon className="h-32 w-32 text-primary animate-bounce" />
        </div>

        {/* Dynamic celebration message */}
        <div className="space-y-2">
          <div className="text-6xl animate-pulse">{celebration.emoji}</div>
          <h1 className="text-4xl font-bold text-foreground animate-in fade-in slide-in-from-bottom-4 duration-500">
            {celebration.message}
          </h1>
        </div>

        <div className="space-y-3">
          <p className="text-xl font-semibold text-foreground">
            All Done!
          </p>
          <p className="text-lg text-muted-foreground">
            There are no more responses to review at this time.
          </p>
        </div>

        <Button
          onClick={() => navigate(appUrls.home)}
          size="lg"
          className="mt-6"
        >
          <Home className="h-5 w-5 mr-2" />
          Back to Home
        </Button>
      </div>
    </div>
  );
};
